import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-05b3545a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "detail"
};
var _hoisted_2 = {
  class: "content"
};
var _hoisted_3 = {
  class: "title"
};
var _hoisted_4 = {
  class: "message"
};
var _hoisted_5 = {
  class: "bookTitle"
};
var _hoisted_6 = {
  class: "bookTime"
};
var _hoisted_7 = {
  class: "bookTime"
};
var _hoisted_8 = {
  class: "bookContent"
};
var _hoisted_9 = ["innerHTML"];
var _hoisted_10 = {
  class: "master"
};

var _hoisted_11 = /*#__PURE__*/_createTextVNode(" 上一章 ");

var _hoisted_12 = [_hoisted_11];

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "vertival"
  }, null, -1);
});

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "vertival"
  }, null, -1);
});

var _hoisted_15 = /*#__PURE__*/_createTextVNode(" 下一章 ");

var _hoisted_16 = [_hoisted_15];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _directive_debounce = _resolveDirective("debounce");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "书籍详情",
    back: true
  }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.detail.chapterName), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.detail.data.bookName), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.detail.data.author), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.detail.data.createTime), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
    innerHTML: _ctx.detail.bookcontent
  }, null, 8, _hoisted_9)])]), _createElementVNode("div", _hoisted_10, [_withDirectives(_createElementVNode("div", {
    class: "li",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.lastChapter && _ctx.lastChapter.apply(_ctx, arguments);
    })
  }, _hoisted_12, 512), [[_directive_debounce]]), _hoisted_13, _createElementVNode("div", {
    class: "li",
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    function () {
      return _ctx.toChapterDetail && _ctx.toChapterDetail.apply(_ctx, arguments);
    })
  }, " 目录 "), _hoisted_14, _withDirectives(_createElementVNode("div", {
    class: "li",
    onClick: _cache[2] || (_cache[2] = //@ts-ignore
    function () {
      return _ctx.nextChapter && _ctx.nextChapter.apply(_ctx, arguments);
    })
  }, _hoisted_16, 512), [[_directive_debounce]])])])], 64);
}